import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 194.06 201.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M194.06 100.8c0-53.6-43.5-97.1-97.1-97.1S-.14 47.2-.14 100.8c0 48.5 35.5 88.7 82 95.9v-67.9h-24.8v-28h24.8V79.4c0-24.3 14.4-37.8 36.6-37.8 10.6 0 21.6 2 21.6 2v23.7h-12.2c-12.1 0-15.9 7.6-15.9 15.2v18.2h27l-4.3 28h-22.7v67.9c44.6-7.1 82.1-47.3 82.1-95.8" }, null, -1)
  ]))]))
}
export default { render: render }